import { DatePicker } from './../components/date_picker_controller';
import { IDay, IWeekDay } from './../date_picker_interface';

export class DatePickerBaseServant {
  buildWeekDayObject(momentObj: moment.Moment, dayOfWeek?: number, showDay?: boolean): IWeekDay {
    return {
      date: moment(momentObj),
      displayDate: momentObj.format('DD'),
      day: momentObj.format('ddd'),
      month: momentObj.format('MMM'),
      year: momentObj.format('YYYY'),
      show: showDay ? showDay : false,
      day_week: dayOfWeek ? dayOfWeek : 0
    };
  }

  buildTimeObject(momentObj: moment.Moment, useBlanks?: boolean): IDay {
    return {
      date: moment(momentObj),
      displayDate: useBlanks ? '' : momentObj.format('DD'),
      day: useBlanks ? '' : momentObj.format('ddd'),
      day_week: useBlanks ? 0 : momentObj.day(),
      time: momentObj.format('hh:mm A'),
      am: momentObj.format('A') === 'AM' ? true : false,
      selected: false
    };
  }

  getWeek(date: moment.Moment, datePicker: DatePicker): IWeekDay[] {
    let week: IWeekDay[] = [];
    let new_date = moment(date).add(0, 'days');
    datePicker.previous_week_firstdate = date.subtract(7, 'days');
    week.push(this.buildWeekDayObject(new_date, 0, false));

    _.times(6, (i) => {
      let currentDate = new_date.add(1, 'days');
      week.push(this.buildWeekDayObject(currentDate, i + 1, i > 4 ? false : true));
    });
    datePicker.current_week_lastdate = new_date.add(1, 'days');
    return week;
  }
}

angular.module('ui-ng-mobile-date-picker').service('ngDatePickerBaseServant', DatePickerBaseServant);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-mobile-date-picker/src/servants/date_picker_base_servant.ts